import { useRef, useState } from "react";

export default function Filter({
  records,
  search,
  downloadExcel,
  downloadUserPDF,
}) {
  const searchRef = useRef();
  const [searchuser, setSearchUser] = useState("");

  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {records}
        </button>
      </div>
      <div className="filterright">
        <div className="margin-right">
          <input
            ref={searchRef}
            type="text"
            name="search"
            id="search"
            autoComplete="new-password"
            placeholder="Search Super"
            class="input bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white "
            value={searchuser}
            onChange={(e) => {
              setSearchUser(e.target.value);
              search(e.target.value);
            }}
          />
        </div>

        <button
          onClick={downloadExcel}
          className={"NavLinkBtn hover marginright unselectlink"}
        >
          EXCEL
        </button>
        <button
          onClick={downloadUserPDF}
          className={"NavLinkBtn hover marginright unselectlink"}
        >
          PDF
        </button>
      </div>
    </div>
  );
}
